const Builder = require('../BuilderBase');

module.exports = class LiveDataList extends Builder {
    constructor(title, properties) {
        super('list_LiveDataList', title, properties);
    }
};
